
  // Faux lazy load
  var fn_faux_lazyload_hc_widgets = function () {
    //
    var all_widgets = $(".js-faux_lazy_load__wrapper .content-widget__wrapper");
    var hideable_widgets = $(".js-faux_lazy_load__wrapper .content-widget__wrapper.d-none");
    var toggler = $(".js-faux_lazy_load__wrapper").next().find(".js-faux_lazy_load_toggler");
  
    // Making widgets tabbable for later focus
    $(all_widgets).attr('tabindex','0');
  
    // Searching for hc widgets that can get visibility (those with d-none)
    for(var i=0; i < hideable_widgets.length; i++){
      var widget = hideable_widgets[i];
      //
      $(widget).attr('data-hidable','tobehidden');
      //$(widget).attr('tabindex','0');
      $(widget).addClass('js-faux_lazy_toggable');
    }

    // $(".js-faux_lazy_load_toggler").on('click', function (e) {
    toggler.on('click', function (e) {
      //
      var $data_to_toogle =  $(this).parent().siblings('.js-faux_lazy_load__wrapper').children().find('.js-faux_lazy_toggable');
  
      $data_to_toogle.toggleClass('d-none d-flex');

      $(this).toggleClass('js_toggler_closed js_toggler_opened');

      // See: https://www.apamphilon.com/snippets/show-moreless-text-homepage-more__read-onclick-function-prev-toggleclassheight-get-text-button-var-text-text/
      // > get text for the button
      var btn = $(this).html();
      // > set text according to current text
      $(this).html(btn == "Voir moins d'indicateurs" ? "Voir plus d'indicateurs" : "Voir moins d'indicateurs");

      // p:eq(1)
      $('html, body').animate({
        scrollTop: $($data_to_toogle).eq(0).offset().top
      }, 800);

      // Sending focus from button to First ".js-faux_lazy_toggable"
      $data_to_toogle.eq(0).focus();

    })
  //
  };
